module.exports = __webpack_public_path__ + "static/award4-eafb04ab4816013b5e0f2a408b87465f.png";